module.exports = "https://s.pinimg.com/webapp/style/images/clickthroughImage-803cd6e0.png";